import React from "react";

import { Checkbox } from "@king-ict/eupisi-ui/components/Checkbox";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IProps {
  isMinorityOrReligiousSchool: boolean;
  handleMinorityOrReligiousSchoolChange: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

export const MinorityReligiousCheckbox = ({
  isMinorityOrReligiousSchool,
  handleMinorityOrReligiousSchoolChange,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Col md={8}>
      <Checkbox
        label={t("institutionDataStep.nationalMinorityOrReligiousSchoolSelect")}
        checked={isMinorityOrReligiousSchool}
        onChange={handleMinorityOrReligiousSchoolChange}
        infoText={t(
          "institutionDataStep.nationalMinorityOrReligiousSchoolSelectInfo"
        )}
      />
    </Col>
  );
};
